import { z } from 'zod';

export const TopLevelAnalysisResult = z
  .object({
    success: z.boolean(),
  })
  .describe('TopLevelAnalysisResult');

export type TopLevelAnalysisResult = z.infer<typeof TopLevelAnalysisResult>;
